import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { filter, switchMap } from 'rxjs/operators';
import { Client } from 'src/app/domain/models';
import { ClientService } from 'src/app/domain/services/client.service';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';
import { CurrentApplicationService } from '../../services/current-application.service';
import { ApplicationService } from './../../../application/services';
import { Application, ProviderContact } from './../../models';

@Component({
    selector: 'app-application-submitted',
    templateUrl: './application-submitted.component.html',
    styleUrls: ['./application-submitted.component.scss'],
    standalone: false
})
export class ApplicationSubmittedComponent implements OnInit {
    providerContacts: ProviderContact[] | undefined;
    client: Client | undefined;
    application: Application | undefined;
    headerHtml: string = '';
    footerHtml: string = '';

    constructor(
        private readonly applicationService: ApplicationService,
        private readonly currentAppService: CurrentApplicationService,
        private readonly _client: ClientService,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {
        this.currentAppService.load();
    }

    ngOnInit() {
        this._googleAnalyticsService.pageView('Application: Submitted');
        this._client.latest.subscribe((client) => {
            this.client = client;
        });
        this.currentAppService.latest
            .pipe(
                filter(
                    (application) =>
                        application !== null &&
                        application !== undefined &&
                        application.applicationId != undefined
                ),
                switchMap((application: Application | undefined) => {
                    this.application = application;
                    this.headerHtml = this.normalizeText(
                        this.client?.submittedPageHeaderHtml || ''
                    );
                    this.footerHtml = this.normalizeText(
                        this.client?.submittedPageFooterHtml || ''
                    );
                    return this.applicationService.getSelectedProviderContacts(
                        application!.applicationId!
                    );
                })
            )
            .subscribe((result) => {
                this.providerContacts = result;
            });
    }

    normalizeText(template: string): string {
        const formattedDate = formatDate(
            this.application?.submitDate || new Date(),
            'MM/dd/yyyy',
            'en-US'
        );
        template = template.replace('{date}', formattedDate);

        template = template.replace(
            '{provider_link}',
            `${runtimeConfig.clientCode}/provider`
        );

        return template;
    }
}
